<template>
  <grid-container-fi
    v-if="requestHandlingFeeBanner"
    class="handling-fee-limit-banner-fi"
    grid-class="fi-h-full"
    :container="false"
  >
    <div class="handling-fee-limit-banner-fi__content fi-col-span-12">
      <span class="handling-fee-limit-banner-fi__text">
        {{ $dict.get('handling-Fee-Banner.Banner', [handlingFeeLimit || '']) }}
      </span>
      <icon-fi
        class="handling-fee-limit-banner-fi__close"
        icon="close"
        @click="close"
      />
    </div>
  </grid-container-fi>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';
import { computed } from 'vue';
import { useStore } from 'vuex';

import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useHandlingFeeCookie } from '@/components/handling-fee-limit-banner-fi/handlingFeeCookie';

defineOptions({
  name: 'HandlingFeeLimitBannerFi',
});

const props = defineProps<{
  handlingFeeLimit: string | null;
}>();

const store = useStore();
const { disableHandlingFeeLimitBanner } = useHandlingFeeCookie();

const requestHandlingFeeBanner = computed(
  () =>
    store.getters['navigation/requestHandlingFeeBanner'] &&
    props.handlingFeeLimit !== null &&
    !store.getters['navigation/isAssistedServiceSalesforce'],
);

const close = () => {
  disableHandlingFeeLimitBanner();
  store.commit('navigation/ENABLE_HANDLING_FEE_BANNER', false);
};
</script>

<style scoped src="./handling-fee-limit-banner-fi" />
